import { Panel, Empty, fmt, pct } from "./kit";
import { ShotZones, zonesFromSeason } from "./ShotZones";

const ma = (m, a) => `${m ?? 0}-${a ?? 0}`;
const KEYS = ["pts", "oreb", "dreb", "reb", "ast", "stl", "blk", "tov", "pf", "fgm", "fga", "fg3m", "fg3a", "ftm", "fta", "eff"];

const sumLines = (lines) => {
  const t = Object.fromEntries(KEYS.map((k) => [k, 0]));
  const zones = {};
  lines.forEach((l) => {
    KEYS.forEach((k) => { t[k] += Number(l[k] ?? 0); });
    Object.entries(l.zones ?? {}).forEach(([z, v]) => {
      zones[z] = { m: (zones[z]?.m ?? 0) + (v?.m ?? 0), a: (zones[z]?.a ?? 0) + (v?.a ?? 0) };
    });
  });
  t.fg_pct = t.fga ? (100 * t.fgm) / t.fga : null;
  return { t, zones };
};

const Row = ({ name, l, total }) => (
  <tr className={`border-t border-[#1E293B] font-mono-gd ${total ? "bg-[#162032] font-bold text-white" : "text-slate-200"}`}>
    <td className="px-3 py-2 font-sans">{name}</td>
    <td className="px-3 py-2 text-[#39FF14]">{fmt(l.pts)}</td>
    <td className="px-3 py-2">{fmt(l.reb)} <span className="text-slate-500">({l.oreb ?? 0}/{l.dreb ?? 0})</span></td>
    <td className="px-3 py-2">{fmt(l.ast)}</td><td className="px-3 py-2">{fmt(l.stl)}</td><td className="px-3 py-2">{fmt(l.blk)}</td>
    <td className="px-3 py-2">{fmt(l.tov)}</td><td className="px-3 py-2">{fmt(l.pf)}</td>
    <td className="px-3 py-2">{ma(l.fgm, l.fga)}</td><td className="px-3 py-2">{ma(l.fg3m, l.fg3a)}</td><td className="px-3 py-2">{ma(l.ftm, l.fta)}</td>
    <td className="px-3 py-2">{pct(l.fg_pct)}</td><td className="px-3 py-2">{fmt(l.eff)}</td>
  </tr>
);

export function BoxScore({ lines, names }) {
  const entries = Object.entries(lines ?? {});
  if (!entries.length) return <Empty title="No box score yet" text="Player lines appear once events are logged for this game." />;
  const { t, zones } = sumLines(entries.map(([, l]) => l));
  const sorted = entries.sort(([, a], [, b]) => (b.pts ?? 0) - (a.pts ?? 0));
  return (
    <div className="space-y-6">
      <Panel>
        <h2 className="mb-4 font-display text-2xl font-bold uppercase text-white">Box score</h2>
        <div className="overflow-x-auto">
          <table className="w-full min-w-[860px] text-left text-sm" data-testid="box-score-table">
            <thead><tr className="font-mono-gd text-[11px] uppercase tracking-wider text-slate-400">
              {["Player", "PTS", "REB (O/D)", "AST", "STL", "BLK", "TOV", "PF", "FG", "3P", "FT", "FG%", "EFF"].map((h) => <th key={h} className="px-3 py-2">{h}</th>)}
            </tr></thead>
            <tbody>
              {sorted.map(([pid, l]) => <Row key={pid} name={names[pid] ?? "Player"} l={l} />)}
              <Row name="Team" l={t} total />
            </tbody>
          </table>
        </div>
      </Panel>
      <Panel>
        <h2 className="mb-4 font-display text-2xl font-bold uppercase text-white">Team shot zones</h2>
        <ShotZones zones={zonesFromSeason(zones)} testid="game-shot-zones" />
      </Panel>
    </div>
  );
}
